module.exports = __webpack_public_path__ + "img/square-phone-flip.668d34ae.svg";